import React from "react"
import TextField from "material-ui/TextField"
import Dialog from "material-ui/Dialog"
import FlatButton from "material-ui/FlatButton"
import strings from "../../../localization/strings"
import AccountStore from "../../../stores/AccountStore"
import * as utils from "../../../helpers/utils"
import * as api from "../../../api"
import { IHierarchyItem, IHierarchyDefinition, IHierarchyItemForAccountLevel } from "../../../models"
import autobind from "class-autobind"
interface IProps {
	hierarchyDefinition: IHierarchyDefinition
	currentHierarchyItem: IHierarchyItem | IHierarchyItemForAccountLevel
	handleAdd(hierarchyItem: IHierarchyItem): void
	handleClose(): void
}
interface IState {
	name: string
	costCenter: string
	payrollExportName: string
	externalID: string
	errorName: string
	errorCostCenter: string
}

export default class AddHierarchyItemDialog extends React.Component<IProps, IState> {
	constructor(props) {
		super(props)
		this.state = {
			name: "",
			costCenter: "",
			payrollExportName: "",
			externalID: "",
			errorName: "",
			errorCostCenter: ""
		}
		autobind(this)
	}

	checkValidate() {
		let validate = true
		if (this.state.name.trim() === "") {
			this.setState({ errorName: strings.This_field_is_required })
			validate = false
		}
		else {
			const parentId = (this.props.currentHierarchyItem as IHierarchyItemForAccountLevel).level !== undefined ?
				null :
				(this.props.currentHierarchyItem as IHierarchyItem).Id
			if (AccountStore.getCurrentAccount().HierarchyItems.filter(item => item.ParentId === parentId).find(item => item.Label === this.state.name.trim())) {
				this.setState({ errorName: strings.The_name_must_be_unique })
				validate = false
			}
			else {
				this.setState({ errorName: "" })
			}
		}

		return new Promise(resolve =>
			!validate ?
				resolve(false) :
				this.state.costCenter.trim() ?
					api.checkValidateHierarchyCostCode(AccountStore.getCurrentAccount().Id, null, this.state.costCenter.trim()).then(res =>
						this.setState({ errorCostCenter: res.data === false ? strings.Cost_Center_is_duplicated : "" }, () =>
							resolve(res.data)
						)
					) :
					this.setState({ errorCostCenter: "" }, () => resolve(true))
		)
	}

	async handleRequestSave() {
		const validate = await this.checkValidate()
		if (!validate) return
		const hierarchyItem = {
			Id: utils.guid(),
			Label: this.state.name.trim(),
			CostCenter: this.state.costCenter.trim(),
			ExternalId: this.state.externalID.trim(),
			PayrollExportName: this.state.payrollExportName.trim(),
			HierarchyDefinitionId: this.props.hierarchyDefinition.Id,
			ParentId: (this.props.currentHierarchyItem as IHierarchyItem).Id ? (this.props.currentHierarchyItem as IHierarchyItem).Id : null //null is the root case
		} as IHierarchyItem

		this.props.handleAdd(hierarchyItem)
	}

	render() {
		return (
			<Dialog
				open
				actionsContainerClassName="AddHierarchyItemNewDialog"
				title={"Add New " + this.props.hierarchyDefinition.Label}
				actions={[
					<FlatButton data-intercom-target={"menu-Hierarchy-Children-Btn-CloseAddHierarchyDialog"} label={strings.CANCEL} secondary onTouchTap={this.props.handleClose} />,
					<FlatButton data-intercom-target={"menu-Hierarchy-Children-Btn-SaveHierarchy"} label={strings.SAVE} primary onTouchTap={this.handleRequestSave} />
				]}
			>
				<div style={{ padding: 30 }}>
					<div style={{ display: "flex", flexWrap: "wrap" }}>
						<TextField
							data-intercom-target={"menu-Hierarchy-Children-Entry-Name"}
							floatingLabelText={strings.Name}
							value={this.state.name}
							onChange={e => this.setState({ name: e.target.value.substr(0, 60) }, () => this.checkValidate())}
							errorText={this.state.errorName}
						/>
						<TextField
							data-intercom-target={"menu-Hierarchy-Children-Entry-CostCenter"}
							floatingLabelText={strings.CostCenter}
							value={this.state.costCenter}
							onChange={e => this.setState({ costCenter: e.target.value.substr(0, 40) }, () => this.checkValidate())}
							errorText={this.state.errorCostCenter}
							style={{ paddingLeft: 70 }}
						/>
					</div>
					<div style={{ display: "flex", flexWrap: "wrap" }}>
						<TextField
							data-intercom-target={"menu-Hierarchy-Children-Entry-PayrollExportName"}
							floatingLabelText={strings.PayrollExportName}
							value={this.state.payrollExportName}
							onChange={e => this.setState({ payrollExportName: e.target.value.substr(0, 40) })}
						/>
						<TextField
							data-intercom-target={"menu-Hierarchy-Children-Entry-ExternalId"}
							floatingLabelText={strings.External_ID}
							value={this.state.externalID}
							onChange={e => this.setState({ externalID: e.target.value.substr(0, 40) })}
							style={{ paddingLeft: 70 }}
						/>
					</div>
				</div>
			</Dialog>
		)
	}
}